import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import { convertTemperature, convertTemperatureUnit, momentFormat } from '#helper';

const TooltipAlert = styled('div')({
  marginTop: 2
});

const AlertTooltip = styled(Tooltip, {
  shouldForwardProp: prop => prop !== 'alert'
})(({ alert }) => ({
  ...(alert && { color: '#FF4635' })
}));

export default function AlertIcon(props) {
  const { device, iconProps, stopPropagation, devicesWithExcursions, account } = props;

  const excursionMetrics = useMemo(() => devicesWithExcursions.reduce((a, c) => {
    c.excursions.forEach(e =>
      a.push({ ...e, identifier: e.id, uid: c.uid, title: c.title }));
    return a;
  }, []), [devicesWithExcursions]);

  const excursion = device.projectAlertId && excursionMetrics.find(e => e.uid === device.uid);

  return (
    device.showAlertIcon ?
      <AlertTooltip
        alert={Boolean(excursion)}
        title={
          <div>
            {device.alertLabel ? `Threshold alert: ${device.alertLabel}` : 'Does not have an alert'}
            {excursion ?
              <TooltipAlert>
                {`Value: ${convertTemperature(excursion.value, account?.measurementSystem)} ${
                  excursion.identifier === 'temperature' ? convertTemperatureUnit(account?.measurementSystem) : excursion.unit
                }`}
                <TooltipAlert>{`Time: ${momentFormat(new Date(excursion.timestamp), account, 'dateTimePartial')}`}</TooltipAlert>
              </TooltipAlert> :
              null}
          </div>
        }
        onClick={stopPropagation}
      >
        {device.alertOn ?
          <NotificationsActiveRoundedIcon {...iconProps} /> :
          <NotificationsOffOutlinedIcon {...iconProps} />}
      </AlertTooltip> :
      null
  );
}
